import { Routes } from "@angular/router";
import {SELECT_CONTRACT_BACKOFFICE} from "@modules/backoffice/select-profile/const/identity-component";

export const BACKOFFICE_ROUTERS: Routes = [
    {
        path: '',
        redirectTo: 'menu-inicial',
        pathMatch: 'full',
    },
    {
        path: 'menu-inicial',
        loadChildren: () =>
            import('@modules/backoffice/main-menu-backoffice/main-menu-backoffice.module').then(
                (m) => m.MainMenuBackofficeModule
            ),
    },
    {
        path: 'logistica',
        children: [
            {
                path: '',
                redirectTo: 'estoque-logistica',
                pathMatch: 'full',
            },
            {
                path: 'estoque-logistica',
                loadChildren: () =>
                    import('@modules/backoffice/reports/reports.module').then(
                        (m) => m.ReportsModule
                    ),
            },
            {
                path: 'historico-importacoes',
                loadChildren: () =>
                    import('@modules/backoffice/import-history/import-history.module').then(
                        (m) => m.ImportHistoryModule
                    ),
            },
            {
                path: 'pedidos-tag',
                loadChildren: () =>
                    import('@modules/backoffice/request/request.module').then(
                        (m) => m.RequestModule
                    ),
            },
        ],
    },
    {
        path: 'gestao-contratos',
        children: [
            {
                path: '',
                redirectTo: 'alteracao-contratual',
                pathMatch: 'full',
            },
            {
                path: 'alteracao-contratual',
                loadChildren: () =>
                    import('@modules/backoffice/contractual-alteration/contractual-alteration.module').then(
                        (m) => m.ContractualAlterationModule
                    ),
            },
            {
                path: 'bloqueio-financeiro-pospago/acessar-contrato',
                loadChildren: () =>
                    import('@modules/backoffice/select-profile/select-profile-back-office.module').then(
                        (m) => m.SelectProfileBackOfficeModule
                    ),
                data: {
                    idComponent: SELECT_CONTRACT_BACKOFFICE.ID_MANAGER_FINANCIAL_POS
                },
            },
            {
                path: 'bloqueio-desbloqueio-financeiro',
                loadChildren: () =>
                    import('@modules/backoffice/financial-blocking-unblocking/financial-blocking-unblocking.module').then(
                        (m) => m.FinancialBlockingUnblockingModule
                    ),
            },
            {
                path: 'seguro-vidros',
                loadChildren: () =>
                    import('@modules/backoffice/insurance-glass/insurance-glass.module').then(
                        (m) => m.InsuranceGlassModule
                    ),
            },
        ],
    },
    {
        path: 'atendimento',
        children: [
            {
                path: '',
                redirectTo: 'acessar-contrato',
                pathMatch: 'full',
            },
            {
                path: 'acessar-contrato',
                loadChildren: () =>
                    import('@modules/backoffice/select-profile/select-profile-back-office.module').then(
                        (m) => m.SelectProfileBackOfficeModule
                    ),
              data: {
                idComponent: SELECT_CONTRACT_BACKOFFICE.ID_MANAGER_CONTRACT
              },
            },
            {
                path: 'operacoes-lote',
                children: [
                  {
                    path: '',
                    redirectTo: 'transferencia-veiculos',
                    pathMatch: 'full',
                  },
                  {
                    path: 'transferencia-veiculos',
                    loadChildren: () =>
                        import('@modules/backoffice/batch-vehicle-transfer/batch-vehicle-transfer.module').then(
                            (m) => m.BatchVehicleTransferModule
                        ),
                  }
                ]
            }
        ],
    },
    {
        path: 'financeiro',
        children: [
            {
                path: '',
                redirectTo: 'conciliacao-repasse-parceiros',
                pathMatch: 'full',
            },
            {
                path: 'conciliacao-repasse-parceiros',
                loadChildren: () =>
                    import('@modules/backoffice/transaction-partners-conciliation/transaction-partners-conciliation.module').then(
                        (m) => m.TransactionPartnersConciliationModule
                    )
            },
            {
                path: 'conciliacao-transacao',
                loadChildren: () =>
                    import('@modules/backoffice/transaction-conciliation/transaction-conciliation.module').then(
                        (m) => m.TransactionConciliationModule
                    ),
            },
            {
                path: 'chargeback',
                loadChildren: () =>
                    import('@modules/backoffice/chargeback-report/chargeback-report.module').then(
                        (m) => m.ChargebackReportModule
                    ),
            },
            {
                path: 'calendario-de-feriados',
                loadChildren: () =>
                    import('@modules/backoffice/holidays-calendar/holidays-calendar.module').then(
                        (m) => m.HolidaysCalendarModule
                    ),
            },
            {
                path: 'transacoes-cartao-de-credito',
                loadChildren: () =>
                    import('@modules/backoffice/financial-sales-report/financial-sales-report.module').then(
                        (m) => m.FinancialSalesReportModule
                    ),
            },
            {
                path: 'viagens-expiradas',
                loadChildren: () =>
                    import('@modules/backoffice/trip-expirated/trip-expirated.module').then(
                        (m) => m.TripExpiratedModule
                    ),
            },
            {
                path: 'reajustes-isencoes',
                loadChildren: () =>
                    import('@modules/backoffice/readjustments-and-exemptions/readjustments-and-exemptions.module').then(
                        (m) => m.ReadjustmentsAndExemptionsModule
                    ),
            },
            {
              path: 'faturas',
              loadChildren: () =>
                import('@modules/backoffice/invoice/invoice.module').then(
                  (m) => m.InvoiceModule
                ),
            }
        ]
    },
    {
        path: 'gestao-acessos',
        children: [
            {
                path: '',
                redirectTo: 'cadastrar-consultor',
                pathMatch: 'full',
            },
            {
                path: 'cadastrar-consultor',
                loadChildren: () =>
                    import('@modules/backoffice/user-consultant-create-update/user-consultant-create-update.module').then(
                        (m) => m.UserConsultantCreateUpdateModule
                    ),
            },
            {
                path: 'editar-consultor',
                loadChildren: () =>
                    import('@modules/backoffice/user-consultant-create-update/user-consultant-create-update.module').then(
                        (m) => m.UserConsultantCreateUpdateModule
                    ),
            },
            {
                path: 'visualizar-consultor',
                loadChildren: () =>
                    import('@modules/backoffice/user-consultant-view/user-consultant-view.module').then(
                        (m) => m.UserConsultantViewModule
                    ),
            },
            {
                path: 'fornecedores-vale-pedagio',
                loadChildren: () =>
                    import('@modules/backoffice/toll-voucher-providers/toll-voucher-providers.module').then(
                        (m) => m.TollVoucherProvidersModule
                    ),
            },
            {
                path: 'fornecedores-vale-pedagio/vale-pedagio',
                loadChildren: () =>
                    import('@modules/partner/toll-voucher-partners/toll-voucher-partners.module').then(
                        (m) => m.TollVoucherPartnersModule
                    ),
                data: {
                    isBackOffice: true
                },
            },
            {
                path: 'faturas',
                loadChildren: () =>
                    import('@modules/partner/invoices-partner/invoices-partner.module').then(m => m.InvoicesPartnerModule),
                data: {
                    isBackOffice: true
                },
            },
            {
                path: 'usuarios',
                loadChildren: () =>
                    import('@modules/backoffice/manager-user/manager-user.module').then(
                        (m) => m.ManagerUserModule
                    ),
            }
        ]
    }


]
